import React, { useEffect, useState } from 'react';
import './AffiliateRequestOutcome.scss';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { http, useNavigationService, AlertService } from '../../fx-core';



const AffiliateRequestOutcome = (props: any) => {
    const { navigate, back } = useNavigationService();
    const [request, setRequest] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [adding, setAdding] = useState(false);

    const requestId = props.match?.params?.id;

    const navToDashboard = () => {
        back();
    };

    const getRequestDetails = () => {
    setLoading(true);
    http.get({ url: `affiliate-product/${requestId}/details` }).then((res: any) => {
        setRequest(res.data);
        setAddedSuccessfully(res.data?.AlreadyAddedToStall ?? res.data?.alreadyAddedToStall ?? false);
        setLoading(false);
    }).catch(() => {
        setRequest(null);
        setLoading(false);
    });
};

    const [addedSuccessfully, setAddedSuccessfully] = useState(false);

const handleAddToStall = () => {
    setAdding(true);
    http.post({ url: `affiliate-product/${requestId}/add-to-stall` }).then((res: any) => {
        setAdding(false);
        setAddedSuccessfully(true);
        AlertService.showSuccessMsg('Added to your stall!');
    }).catch((err: any) => {
        setAdding(false);
    });
};

    const navToAffiliateMarketing = () => {
        navigate({
            targetRoute: '/provider/affiliatemarketing',
            targetTitle: 'Affiliated Products',
            targetData: {},
            sourceState: {},
            eventSource: '',
        });
    };

    useEffect(() => {
        if (requestId) {
            getRequestDetails();
        }
    }, [requestId]);

   return (
    <div className="affiliaterequestoutcome-ui">
        <div style={{ height: '85px' }}></div>
        <div className="pt-3 px-4" style={{ backgroundColor: '#f5f1e8' }}>
            <Breadcrumbs aria-label="breadcrumb">
                <span
                    className="pointer"
                    style={{ color: '#f69516', textDecoration: 'underline', fontWeight: 'bold' }}
                    onClick={navToDashboard}
                >
                    Dashboard
                </span>
                <Typography style={{ color: '#3c4858', fontWeight: 500 }}>Request Outcome</Typography>
            </Breadcrumbs>
        </div>

            <div className="mx-4 my-3">
                {loading &&
                    <div className="py-5 text-center">
                        <CircularProgress />
                    </div>
                }

                {!loading && !request &&
                    <div className="py-5 text-center">
                        <div className="font-17"><b>Request not found, or you don't have permission to view it.</b></div>
                    </div>
                }

                {!loading && request && request.requestStatus === 'Accepted' &&
    <Card className="p-4 text-center">
        <CardContent>
            <div className="font-22 pb-2" style={{ color: '#2e7d32' }}>
                <i className="fas fa-check-circle pr-2"></i>
                Your request has been accepted!
            </div>
            <div className="font-16 pb-1">
                Product: <b>{request.itemName}</b>
            </div>
            <div className="font-16 pb-1">
                From: <b>{request.merchantName || request.merchantStallName}</b>
            </div>
            <div className="font-16 pb-1">
                Price: <b>₹{request.itemPrice || request.itemListingPrice || 0}</b>
            </div>
                       <div className="font-16 pb-4">
                Commission: <b>{request.marginNumber}%</b>
            </div>
            {addedSuccessfully ? (
                <div className="font-16" style={{ color: '#2e7d32' }}>
                    <i className="fas fa-check-circle pr-2"></i>
                    Successfully added to your stall!
                </div>
            ) : (
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleAddToStall}
                    disabled={adding}
                >
                    {adding ? 'Adding...' : 'Add This Product To Your Stall'}
                </Button>
            )}
        </CardContent>
    </Card>
}

                                {!loading && request && request.requestStatus === 'Rejected' &&
                    <Card className="p-4 text-center">
                        <CardContent>
                            <div className="font-22 pb-2" style={{ color: '#c62828' }}>
                                <i className="fas fa-times-circle pr-2"></i>
                                Your request has been rejected
                            </div>
                            <div className="font-16 pb-1">
                                Product: <b>{request.itemName}</b>
                            </div>
                            <div className="font-16 pb-1">
                                From: <b>{request.merchantName || request.merchantStallName}</b>
                            </div>
                            <div className="font-16 pb-1">
                                Price: <b>₹{request.itemPrice || request.itemListingPrice || 0}</b>
                            </div>
                            <div className="font-16 pb-4">
                                Proposed Commission: <b>{request.marginNumber}%</b>
                            </div>
                            <div className="font-14 text-muted pb-4">
                                Don't lose this opportunity — browse other affiliate products available for promotion.
                            </div>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={navToAffiliateMarketing}
                            >
                                Browse Other Affiliate Products
                            </Button>
                        </CardContent>
                    </Card>
                }

                {!loading && request && request.requestStatus !== 'Accepted' && request.requestStatus !== 'Rejected' &&
                    <Card className="p-4 text-center">
                        <CardContent>
                            <div className="font-17">This request is still pending a decision.</div>
                        </CardContent>
                    </Card>
                }
            </div>
        </div>
    );
};

export default AffiliateRequestOutcome;